// import external dependencies
import 'jquery';

window.WP_Grid_Builder.on( 'init', function( wpgb ) {
  
  if(wpgb.grid) {
    wpgb.grid.on( 'layout', function( ) {
      // Out Of Stock Card
      const outOfStockCard = $('.fade');
  
      $(outOfStockCard).each( function() {
        $(this).parent().addClass('faded');
      });
  
      // Out Of Stock Tag
      const outOfStockTag = $('.wpgb-layout .tag.out-of-stock');
  
      $(outOfStockTag).each( function() {
        $(this).siblings().remove();
      });
  
      // No Results Price Filter 
      const sliderRange = $('.wpgb-range-facet input');
    
      if($(sliderRange).attr('max') == 0) {
        $('.wpgb-range-facet').parent().parent().hide();
      }
    });

    wpgb.facets.on( 'loaded', function( ) {

      // Closed Filters
      if( $(window).width() > 768 ) {
        $('.wpgb-facet-title:not(.wpgb-sr-only)').next().slideUp(200);
        $('.wpgb-facet-title:not(.wpgb-sr-only)').next().parent().addClass('closed');
      }
    
    });
  }

  // $(document).on('click', '.wpgb-grid-2 a[data-page]', (e) => {
  //   const element = e.currentTarget;
  //   const page_url = $(element).attr('href');
  //   window.location.href = page_url;
  //   wpgb.facets.abort();
  // })
});
